import { NeighborhoodServiceAreaInfo } from 'rwl-shared/dist/models';
import SingleZipPopover from '../Popovers/SingleZipPopover';
import ServiceAreaMarkerContent from './Content/ServiceAreaMarkerContent';
import { usePlacesAutocomplete } from '../../../hooks/usePlacesAutoComplete';
import { useGlobal } from '../../../hooks';
import { BaseMarker, HoverState } from './BaseMarker';
import { getPageUrl, useAnalyticsClickEvent, useMap } from 'rwl-ui';
import { ClickTargets } from 'rwl-shared/dist/models/analytics';
import MultiZipPopover from '../Popovers/MultiZipPopover';

type ServiceAreaMarkerProps = {
    position: google.maps.LatLngLiteral;
    serviceArea?: NeighborhoodServiceAreaInfo;
    serviceAreas?: NeighborhoodServiceAreaInfo[];
    onHover?: (state: HoverState) => void;
    onClick?: () => void;
    isCluster?: boolean;
    totalJobs?: number;
};

export const ServiceAreaMarker = ({
    position,
    serviceArea,
    serviceAreas,
    onHover,
    onClick,
    isCluster,
    totalJobs,
}: ServiceAreaMarkerProps) => {
    const { config } = useGlobal();
    const { setSelectedPlaceId } = usePlacesAutocomplete();
    const { map } = useMap();
    const sendClickEvent = useAnalyticsClickEvent();

    if ((serviceArea && !serviceArea.jobCount) || !map) return null;

    return (
        <div
            onClick={() => {
                if (serviceAreas) return;
                onClick?.();
                setSelectedPlaceId(serviceArea?.placeInfo?.place_id);
                sendClickEvent({
                    url: getPageUrl(),
                    target: ClickTargets.SERVICE_AREA,
                });
            }}
        >
            <BaseMarker
                position={position}
                onMarkerClick={() => undefined}
                onMarkerHover={(state) => {
                    onHover?.(state);
                }}
                markerContent={
                    <ServiceAreaMarkerContent
                        icon={config?.account.mapSettings.icon}
                        iconTint={config?.account.mapSettings.color}
                        jobCount={serviceArea?.jobCount || totalJobs || 0}
                        isCluster={isCluster}
                    />
                }
                popoverContent={
                    isCluster && serviceAreas ? (
                        <MultiZipPopover
                            onClick={(area) => {
                                onClick?.();
                                setSelectedPlaceId(area.placeInfo?.place_id);
                                sendClickEvent({
                                    url: getPageUrl(),
                                    target: ClickTargets.SERVICE_AREA,
                                });
                            }}
                            serviceAreas={serviceAreas}
                        />
                    ) : (
                        serviceArea && (
                            <SingleZipPopover
                                serviceArea={serviceArea}
                                onClick={() => {
                                    onClick?.();
                                    setSelectedPlaceId(
                                        serviceArea.placeInfo?.place_id
                                    );
                                    sendClickEvent({
                                        url: getPageUrl(),
                                        target: ClickTargets.SERVICE_AREA,
                                    });
                                }}
                            />
                        )
                    )
                }
                popoverAnchor="bestCenter"
            />
        </div>
    );
};
